import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bar-chart-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center text-muted p-4"
}

import { computed } from 'vue';
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js';

interface ChartPoint {
  label: string;
  value: number;
}

const chartHeight = 360;
const minBarSlot = 46;


export default /*@__PURE__*/_defineComponent({
  __name: 'BarChart',
  props: {
    points: {},
    valueLabel: {}
  },
  setup(__props: any) {

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const props = __props;

const chartWidth = computed(() => Math.max(600, props.points.length * minBarSlot));

const chartData = computed(() => ({
  labels: props.points.map(p => p.label),
  datasets: [
    {
      label: props.valueLabel || 'Value',
      backgroundColor: '#3277df',
      data: props.points.map(p => p.value)
    }
  ]
}));

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (context: any) => `${context.formattedValue}${props.valueLabel ? ' ' + props.valueLabel : ''}`
      }
    }
  },
  scales: {
    x: {
      ticks: {
        autoSkip: false,
        maxRotation: 45,
        minRotation: props.points.length > 8 ? 45 : 0
      }
    },
    y: {
      beginAtZero: true,
      title: {
        display: !!props.valueLabel,
        text: props.valueLabel
      }
    }
  }
}));

return (_ctx: any,_cache: any) => {
  return (__props.points.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "bar-chart-scroll",
          style: _normalizeStyle({ height: chartHeight + 'px' })
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ width: chartWidth.value + 'px', height: '100%' })
          }, [
            _createVNode(_unref(Bar), {
              data: chartData.value,
              options: chartOptions.value
            }, null, 8, ["data", "options"])
          ], 4)
        ], 4)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, "No data for the selected filters."))
}
}

})